import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const LinkedGoalIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_17622_69772" fill="white">
        <path d="M3 2.75C3 2.19772 3.44772 1.75 4 1.75H20C20.5523 1.75 21 2.19772 21 2.75V8.75C21 9.30228 20.5523 9.75 20 9.75H4C3.44772 9.75 3 9.30228 3 8.75V2.75Z" />
      </mask>
      <path
        d="M3 2.75C3 2.19772 3.44772 1.75 4 1.75H20C20.5523 1.75 21 2.19772 21 2.75V8.75C21 9.30228 20.5523 9.75 20 9.75H4C3.44772 9.75 3 9.30228 3 8.75V2.75Z"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-1-inside-1_17622_69772)"
      />
      <mask id="path-2-inside-2_17622_69772" fill="white">
        <path d="M13 15.25C13 14.6977 13.4477 14.25 14 14.25H20C20.5523 14.25 21 14.6977 21 15.25V21.25C21 21.8023 20.5523 22.25 20 22.25H14C13.4477 22.25 13 21.8023 13 21.25V15.25Z" />
      </mask>
      <path
        d="M13 15.25C13 14.6977 13.4477 14.25 14 14.25H20C20.5523 14.25 21 14.6977 21 15.25V21.25C21 21.8023 20.5523 22.25 20 22.25H14C13.4477 22.25 13 21.8023 13 21.25V15.25Z"
        fill={color}
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-2-inside-2_17622_69772)"
      />
      <path d="M8 8.5V16.5C8 17.0523 8.44772 17.5 9 17.5H14" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default LinkedGoalIcon;
